import { Box, Grid, Typography } from '@mui/material'

import { Address } from '@ecm/data/Address'
import AddressObj from '@ecm/data/Address'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

type PopularAddressesLinksProps = {
  addresses: Address[]
}

type PopularAddressItemProps = {
  address: Address
}

const PopularAddressItem = ({ address }: PopularAddressItemProps) => (
  <Grid key={address.slug} item xs={12} sm={6} md={4} lg={3}>
    <Box
      bgcolor={Color.white.normal}
      border={`1px solid ${Color.smoke.darkest}`}
      borderRadius="4px"
      textAlign="center"
    >
      <Anchor
        href={`/addresses/${address.stateAbbreviation.toLocaleLowerCase()}/${AddressObj.buildSlug(
          address.city
        )}`}
        py="0.75em"
      >
        {address.city} Address
      </Anchor>
    </Box>
  </Grid>
)

export const PopularAddressesLinks = ({ addresses }: PopularAddressesLinksProps) => (
  <Box padding={{ md: '5em 0', xs: '3em 0 6em' }} bgcolor={Color.smoke.lightest}>
    <MainContainer sx={{ position: 'relative' }}>
      <Grid container justifyContent="space-between" alignItems="baseline" spacing={2}>
        <Grid item md={9}>
          <Typography variant="h4" component="h3" mb="0">
            Popular Addresses
          </Typography>
        </Grid>
        <Grid item>
          <Anchor
            sx={{
              bottom: { md: 0, xs: '-70px' },
              left: { md: 0, xs: '50%' },
              position: { md: 'static', xs: 'absolute' },
              transform: { md: 'translate(0,0)', xs: 'translate(-50%,0)' },
            }}
            href={'/addresses'}
            caret
          >
            See all addresses
          </Anchor>
        </Grid>
      </Grid>

      <Grid
        container
        /* eslint-disable sort-keys */
        columnSpacing={{
          sm: 3,
          md: 2,
          lg: 4,
          xl: 6,
        }}
        /* eslint-disable sort-keys */
        rowSpacing={3}
        mt={{ md: '1.5em', xs: '0.5em' }}
      >
        {addresses.map(address => (
          <PopularAddressItem key={address.slug} address={address} />
        ))}
      </Grid>
    </MainContainer>
  </Box>
)

export default { PopularAddresses: PopularAddressesLinks }
